import type { EventType } from 'mitt';
import mitt from 'mitt';

export const createEmitter = <TEvents extends Record<EventType, unknown>>() => {
  const emitter = mitt<TEvents>();

  const on = <TKey extends keyof TEvents>(
    event: TKey,
    callback: (data: TEvents[TKey]) => void
  ) => {
    emitter.on(event, callback);
  };

  const emit = <TKey extends keyof TEvents>(
    event: TKey,
    data?: TEvents[TKey]
  ) => {
    if (data) {
      emitter.emit(event, data);
      return;
    }
    const eventWithoutPayload = event as undefined extends TEvents[TKey]
      ? TKey
      : never;
    emitter.emit(eventWithoutPayload);
  };

  const off = <TKey extends keyof TEvents>(
    event: TKey,
    callback?: (data: TEvents[TKey]) => void
  ) => {
    if (callback) {
      emitter.off(event, callback);
      return;
    }
    emitter.off(event);
  };

  const all = () => {
    return emitter.all;
  };

  return { on, off, emit, all };
};
